import { frontendURL } from '../../../helper/URLHelper';
import SegmentsIndex from './SegmentsIndex.vue';
import ScenariosIndex from './ScenariosIndex.vue';
import ScenarioEditor from './ScenarioEditor.vue';
import TemplatesIndex from './TemplatesIndex.vue';
import WabaTemplatesIndex from './WabaTemplatesIndex.vue';
import DeliveriesIndex from './DeliveriesIndex.vue';
import OperationsIndex from './OperationsIndex.vue';
import SourcesIndex from './SourcesIndex.vue';
import SettingsIndex from './SettingsIndex.vue';

const meta = { permissions: ['administrator'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/automation/waba-templates'),
    name: 'automation_waba_templates_index',
    component: WabaTemplatesIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/segments'),
    name: 'automation_segments_index',
    component: SegmentsIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/scenarios'),
    name: 'automation_scenarios_index',
    component: ScenariosIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/scenarios/:id'),
    name: 'automation_scenarios_edit',
    component: ScenarioEditor,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/templates'),
    name: 'automation_templates_index',
    component: TemplatesIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/deliveries'),
    name: 'automation_deliveries_index',
    component: DeliveriesIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/operations'),
    name: 'automation_operations_index',
    component: OperationsIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/sources'),
    name: 'automation_sources_index',
    component: SourcesIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/automation/settings'),
    name: 'automation_settings_index',
    component: SettingsIndex,
    meta,
  },
];
